import { Sparkles } from 'lucide-react';


export function TopBar() {
    return (
        <div className="border-b border-rose-100 bg-white/95 text-slate-700 backdrop-blur">
            <div className="mx-auto w-full max-w-[1440px] px-4 sm:px-6 lg:px-8 py-2.5">
                <div className="flex items-center justify-between gap-4">
                    <div className="flex min-w-0 items-center gap-3">
                        <span className="inline-flex size-8 shrink-0 items-center justify-center rounded-full bg-[#f51b75] text-white shadow-[0_10px_24px_rgba(245,27,117,0.22)]">
                            <Sparkles className="size-4" />
                        </span>
                        <p className="truncate text-[10px] font-black uppercase tracking-[0.28em] text-[#d80b67] sm:text-xs">
                            Free delivery on orders over 1999
                        </p>
                    </div>

                    <div className="hidden items-center gap-2 md:flex">
                        <span className="rounded-full border border-rose-100 bg-[#fff3f7] px-3 py-1 text-[10px] font-black uppercase tracking-[0.18em] text-[#d80b67]">
                            New drops
                        </span>
                        <span className="rounded-full border border-rose-100 bg-[#fff3f7] px-3 py-1 text-[10px] font-black uppercase tracking-[0.18em] text-[#d80b67]">
                            Fast support
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
}
